// tabs/AcctTab.jsx - Accounting tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Button } from '@mantine/core';

const AcctTab = ({ quoteData, setQuoteData }) => {
  const [acctData, setAcctData] = useState({
    comp: 1,
    div: '',
    dept: '',
    glAcct: '400-00-00',
    glCodeName: 'AEROSPACE SALES'
  });

  const handleChange = (field, value) => {
    setAcctData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        <Grid.Col span={6}>
          <Stack spacing="sm">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={60}>Comp:</Text>
              <NumberInput
                value={acctData.comp}
                variant="filled"
                size="sm"
                w={60}
                styles={{ input: { textAlign: 'center', fontWeight: 'bold', color: 'white', backgroundColor: 'blue' } }}
                onChange={(value) => handleChange('comp', value)}
              />
              <Text size="sm" fw={500} ml="md">Div:</Text>
              <TextInput
                value={acctData.div}
                variant="filled"
                size="sm"
                w={80}
                onChange={(e) => handleChange('div', e.target.value)}
              />
              <Text size="sm" fw={500} ml="md">Dept:</Text>
              <TextInput
                value={acctData.dept}
                variant="filled"
                size="sm"
                w={80}
                onChange={(e) => handleChange('dept', e.target.value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Button variant="default" size="xs" style={{ padding: '0 8px' }}>
                📄
              </Button>
              <Text size="sm" fw={500} w={60}>GL Acct:</Text>
              <TextInput
                value={acctData.glAcct}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('glAcct', e.target.value)}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>GL Code Name:</Text>
              <TextInput
                value={acctData.glCodeName}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => handleChange('glCodeName', e.target.value)}
              />
            </Group>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default AcctTab;